import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { H2, TextMain } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import magnifyingGlassPng from '/img/icons/magnifying-glass.png';
import magnifyingGlassWebp from '/img/icons/magnifying-glass.webp';

interface NoInvitePartnersProps {
  className?: string;
}

const NoInvitePartners: FC<NoInvitePartnersProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'w-full flex flex-col items-center justify-center',
        className,
      )}
    >
      <Picture
        className="w-16 h-16 shrink-0 mb-4"
        img={magnifyingGlassPng}
        webp={magnifyingGlassWebp}
        alt="magnifying glass"
      />
      <H2 weight="extrabold" className="mb-2">
        {t('No invited partners')}
      </H2>
      <TextMain className="!text-white/40 max-w-[14rem] !leading-1.2 text-center">
        {t('Bring your friends into the game and earn together!')}
      </TextMain>
    </div>
  );
};

export { NoInvitePartners };
